import React from 'react';
import { Container, Row, Col} from 'react-bootstrap';
import { Consts } from "consts";
import { useTranslation } from "react-i18next";
import Page from "components/page";
import { Paths } from "paths";
const AboutPage = () => {
  const [t] = useTranslation('common');

  return (
    <Page title={t('About LocalIQ - On-Premise LLM Inference Server')} description={t('Learn about LocalIQ, your trusted solution for deploying and managing on-premise LLM inference servers with flexible options.')} canonicalUrl={Paths.About.path}>
        <Container className="min-vh-100 my-5">
            <Row className="justify-content-md-center">
                <Col>
                <h1 className="mb-4">{t('About')} {Consts.ProjectName}</h1>
                <p>
                {t('Welcome to')} <strong>{Consts.ProjectName}</strong>! {t('Your trusted solution for deploying and managing LLM inference servers.')}
                </p>

                <h3 className="mt-5 mb-3">{t('What We Offer')}</h3>
                <ul>
                    <li>
                    <strong>{t('Flexible Deployment')}:</strong> {t('Deploy your LLM inference server on-premise or in the cloud with comprehensive configuration options.')}
                    </li>
                    <li>
                    <strong>{t('Model Management')}:</strong> {t('Efficiently manage multiple LLM models with built-in versioning and API endpoint generation.')}
                    </li>
                    <li>
                    <strong>{t('Performance Monitoring')}:</strong> {t('Track model inference metrics, latency, and resource utilization with detailed monitoring and logging.')}
                    </li>
                </ul>

                <h3 className="mt-5 mb-3">{t('Our Mission')}</h3>
                <p>
                {t('At')} <strong>{Consts.ProjectName}</strong> {t(' our mission is to simplify LLM deployment and management, enabling organizations to leverage the power of large language models efficiently and securely.')}
                </p>

                <h3 className="mt-5 mb-3">{t('Want to Help or Partner with Us?')}</h3>
                <p>
                {t('If you\'d like to contribute to our project or explore partnership opportunities, feel free to reach out to')} {' '}
                <a href={`mailto:${Consts.ContactEmail}`}>{Consts.ContactEmail}</a>.
                </p>
                </Col>
            </Row>
        </Container>
    </Page>
  );
};

export default AboutPage;